import Backbone from 'backbone';
import equipment from './equipment';
import { uniq, flatten, sortBy } from 'lodash';

const equipmentCollection = Backbone.Collection.extend({
  initialize: function(){
    this.url = '/equipment';
    this.model = equipment
  },

  alphabetical: function(){
    return sortBy(this.models, function(equipment){
      return equipment.get('name');
    });
  },

  tags: function() {
    return uniq(flatten(this.models.map((item) => {
      return item.attributes.tags.map(tag => tag.name);
    })))
  }
});

export default equipmentCollection;
